(function () {
  var core = window.DPPThemeProduct || {}
  var getFocusableElements = core.getFocusableElements
  var trapFocusWithin = core.trapFocusWithin
  var setBodyScrollLock = core.setBodyScrollLock
  var prefersReducedMotion = core.prefersReducedMotion
  function setupProductGallery() {
    var galleries = Array.prototype.slice.call(document.querySelectorAll('[data-product-gallery]'))
    if (galleries.length === 0) return
    galleries.forEach(function (gallery) {
      var stageItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-item]'))
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'))
      if (stageItems.length === 0 && thumbs.length === 0) return
      var stage = gallery.querySelector('[data-gallery-main-stage]')
      var mainImage = gallery.querySelector('[data-gallery-main-image]')
      var prevButton = gallery.querySelector('[data-gallery-prev]')
      var nextButton = gallery.querySelector('[data-gallery-next]')
      var indexBadge = gallery.querySelector('[data-gallery-index]')
      var thumbsContainer = gallery.querySelector('[data-gallery-thumbs]')
      var lightbox = gallery.querySelector('[data-gallery-lightbox]')
      var lightboxItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-lightbox-item]'))
      var lightboxImage = gallery.querySelector('[data-gallery-lightbox-image]')
      var lightboxIndex = gallery.querySelector('[data-gallery-lightbox-index]')
      var lightboxClose = gallery.querySelector('[data-gallery-lightbox-close]')
      var lightboxPrev = gallery.querySelector('[data-gallery-lightbox-prev]')
      var lightboxNext = gallery.querySelector('[data-gallery-lightbox-next]')
      var openLightboxButton = gallery.querySelector('[data-gallery-open-lightbox]')
      var lastLightboxTrigger = null
      var stageTouchMoved = false
      var stageTouchStartX = 0
      var stageTouchStartY = 0
      var section = gallery.closest('[data-product-section]')
      var variantSelect = section ? section.querySelector('[data-variant-select]') : null
      var mediaMap = {}
      var activeMediaId = stage ? (stage.getAttribute('data-gallery-active-media-id') || '') : ''
      if (!activeMediaId && mainImage) activeMediaId = mainImage.getAttribute('data-gallery-main-media-id') || ''
      thumbs.forEach(function (thumb) {
        var mediaId = thumb.getAttribute('data-media-id')
        if (mediaId) mediaMap[mediaId] = thumb
      })
      function getMediaDedupeFilename(value) {
        var filename = String(value || '').split('?')[0].split('/').pop().toLowerCase()
        if (!filename) return ''
        return filename
          .replace(/\.(avif|gif|jpe?g|png|webp)$/i, '')
          .replace(/_[0-9a-f-]{8,}$/i, '')
      }
      function getMediaDedupeKey(entry) {
        if (!entry) return ''
        var filenameKey = getMediaDedupeFilename(entry.previewSrc)
        return filenameKey || entry.id || ''
      }
      function dedupeMediaEntries(entries) {
        var seenKeys = {}
        return entries.filter(function (entry) {
          var dedupeKey = getMediaDedupeKey(entry)
          if (!dedupeKey) return true
          if (seenKeys[dedupeKey]) return false
          seenKeys[dedupeKey] = true
          return true
        })
      }
      var allMediaEntries = dedupeMediaEntries(stageItems.length > 0 ? stageItems.map(function (item) {
        var mediaId = item.getAttribute('data-media-id') || ''
        var thumb = mediaMap[mediaId] || null
        var variantIds = thumb
          ? (thumb.getAttribute('data-variant-ids') || '')
            .split(',')
            .map(function (value) {
              return value.trim()
            })
            .filter(Boolean)
          : []
        return {
          thumb: thumb,
          id: mediaId,
          mediaType: item.getAttribute('data-media-type') || 'image',
          previewSrc: item.getAttribute('data-media-preview-src') || '',
          alt: item.getAttribute('data-media-alt') || '',
          attachedToVariant: thumb ? thumb.getAttribute('data-attached-to-variant') === 'true' : false,
          variantIds: variantIds
        }
      }) : thumbs.map(function (thumb) {
        var mediaId = thumb.getAttribute('data-media-id') || ''
        var variantIds = (thumb.getAttribute('data-variant-ids') || '')
          .split(',')
          .map(function (value) {
            return value.trim()
          })
          .filter(Boolean)
        return {
          thumb: thumb,
          id: mediaId,
          mediaType: 'image',
          previewSrc: thumb.getAttribute('data-media-src') || '',
          srcset: thumb.getAttribute('data-media-srcset') || '',
          alt: thumb.getAttribute('data-media-alt') || '',
          attachedToVariant: thumb.getAttribute('data-attached-to-variant') === 'true',
          variantIds: variantIds
        }
      }).filter(function (entry) {
        return entry.id
      }))
      var visibleMediaEntries = allMediaEntries.slice()
      function getMediaEntry(mediaId) {
        return allMediaEntries.find(function (entry) {
          return entry.id === mediaId
        }) || null
      }
      function syncEmbeddedMedia(item, isActive) {
        if (!item) return
        var video = item.querySelector('video')
        if (video && !isActive && typeof video.pause === 'function') video.pause()
        var iframe = item.querySelector('iframe')
        if (!iframe) return
        var iframeSrc = iframe.getAttribute('data-media-src') || iframe.getAttribute('src') || ''
        if (iframeSrc && !iframe.getAttribute('data-media-src')) iframe.setAttribute('data-media-src', iframeSrc)
        if (isActive) {
          if (iframeSrc && iframe.getAttribute('src') !== iframeSrc) iframe.setAttribute('src', iframeSrc)
        } else if (iframe.getAttribute('src')) {
          iframe.setAttribute('src', 'about:blank')
        }
      }
      function setItemVisibility(item, isActive) {
        if (!item) return
        item.classList.toggle('hidden', !isActive)
        item.setAttribute('aria-hidden', isActive ? 'false' : 'true')
        syncEmbeddedMedia(item, isActive)
      }
      function renderActiveMedia(mediaId) {
        activeMediaId = mediaId || ''
        var activeEntry = getMediaEntry(activeMediaId)
        var isLightboxOpen = lightbox && !lightbox.classList.contains('hidden')
        stageItems.forEach(function (item) {
          setItemVisibility(item, item.getAttribute('data-media-id') === activeMediaId)
        })
        lightboxItems.forEach(function (item) {
          var shouldShow = isLightboxOpen && item.getAttribute('data-media-id') === activeMediaId
          setItemVisibility(item, shouldShow)
        })
        if (stage) {
          stage.setAttribute('data-gallery-active-media-id', activeMediaId)
          stage.setAttribute('data-gallery-active-media-type', activeEntry ? activeEntry.mediaType : '')
        }
        if (activeEntry && mainImage && stageItems.length === 0) {
          if (activeEntry.previewSrc) mainImage.setAttribute('src', activeEntry.previewSrc)
          if (activeEntry.srcset) mainImage.setAttribute('srcset', activeEntry.srcset)
          mainImage.setAttribute('alt', activeEntry.alt || '')
          mainImage.setAttribute('data-gallery-main-media-id', activeEntry.id)
        }
        if (activeEntry && lightboxImage && lightboxItems.length === 0) {
          if (activeEntry.previewSrc) lightboxImage.setAttribute('src', activeEntry.previewSrc)
          lightboxImage.setAttribute('alt', activeEntry.alt || '')
        }
      }
      function normalizeVariantMediaText(value) {
        return String(value || '')
          .toLowerCase()
          .replace(/[%_]/g, ' ')
          .replace(/[^a-z0-9]+/g, ' ')
          .replace(/\s+/g, ' ')
          .trim()
      }
      function getMediaFilename(value) {
        var source = String(value || '')
        if (!source) return ''
        return source.split('?')[0].split('/').pop().toLowerCase()
      }
      function getPackSizeFromOption(option) {
        if (!option) return ''
        var variantTitle = option.getAttribute('data-title') || option.textContent || ''
        var normalizedTitle = normalizeVariantMediaText(variantTitle)
        var packMatch = normalizedTitle.match(/(\d+)\s*pack/)
        return packMatch ? packMatch[1] : ''
      }
      function getVariantMediaMatchTokens(option) {
        if (!option) return []
        var variantTitle = option.getAttribute('data-title') || option.textContent || ''
        var normalizedTitle = normalizeVariantMediaText(variantTitle)
        if (!normalizedTitle) return []
        var tokens = [normalizedTitle]
        var packMatch = normalizedTitle.match(/(\d+)\s*pack/)
        if (packMatch) {
          var packSize = packMatch[1]
          tokens.push(packSize + ' pack')
          tokens.push(packSize + 'pack')
          tokens.push(packSize + ' x')
          tokens.push(packSize + 'x')
        }
        return tokens.filter(function (token, index, list) {
          return token && list.indexOf(token) === index
        })
      }
      function findVariantMediaIdFromOption(option) {
        if (!option) return ''
        var featuredMediaId = option.getAttribute('data-featured-media-id') || ''
        if (featuredMediaId && mediaMap[featuredMediaId]) return featuredMediaId
        var tokens = getVariantMediaMatchTokens(option)
        var packSize = getPackSizeFromOption(option)
        if (tokens.length === 0 && !packSize) return ''
        var scoredEntries = allMediaEntries
          .map(function (entry, index) {
            var filename = getMediaFilename(entry.previewSrc)
            var normalizedAlt = normalizeVariantMediaText(entry.alt)
            var normalizedFilename = normalizeVariantMediaText(filename)
            var score = 0
            tokens.forEach(function (token) {
              if (filename.indexOf(token.replace(/\s+/g, '')) !== -1) score += 120
              if (normalizedFilename.indexOf(token) !== -1) score += 90
              if (normalizedAlt.indexOf(token) !== -1) score += 60
            })
            if (packSize) {
              if (filename.indexOf(packSize + 'x') !== -1) score += 140
              if (filename.indexOf(packSize + '-pack') !== -1 || filename.indexOf(packSize + '_pack') !== -1 || filename.indexOf(packSize + 'pack') !== -1) score += 140
              if (new RegExp('[a-z]+-' + packSize + '([-_]|$)').test(filename)) score += 180
              if (new RegExp('(^|[-_])' + packSize + '([-_]|$)').test(filename)) score += 110
              if (new RegExp('(^|\\s)' + packSize + '(\\s|$)').test(normalizedFilename)) score += 80
              if (new RegExp('(^|\\s)' + packSize + '(\\s|$)').test(normalizedAlt)) score += 40
            }
            return {
              entry: entry,
              score: score,
              index: index
            }
          })
          .filter(function (candidate) {
            return candidate.score > 0
          })
          .sort(function (left, right) {
            if (right.score !== left.score) return right.score - left.score
            return left.index - right.index
          })
        return scoredEntries.length > 0 ? scoredEntries[0].entry.id : ''
      }
      function getActiveIndex() {
        var foundIndex = visibleMediaEntries.findIndex(function (entry) {
          return entry.id === activeMediaId
        })
        return foundIndex >= 0 ? foundIndex : 0
      }
      function updateIndexBadge(index) {
        if (!indexBadge) return
        if (visibleMediaEntries.length < 2) {
          indexBadge.classList.add('hidden')
          return
        }
        indexBadge.classList.remove('hidden')
        indexBadge.textContent = (index + 1) + ' / ' + visibleMediaEntries.length
      }
      function updateLightbox(index) {
        if (!lightbox || !lightboxIndex) return
        if (visibleMediaEntries.length < 2) {
          lightboxIndex.classList.add('hidden')
          return
        }
        lightboxIndex.classList.remove('hidden')
        lightboxIndex.textContent = (index + 1) + ' / ' + visibleMediaEntries.length
      }
      function updateGalleryControls() {
        var hasMultipleVisibleEntries = visibleMediaEntries.length > 1
        if (thumbsContainer) thumbsContainer.classList.toggle('hidden', !hasMultipleVisibleEntries)
        if (prevButton) prevButton.classList.toggle('hidden', !hasMultipleVisibleEntries)
        if (nextButton) nextButton.classList.toggle('hidden', !hasMultipleVisibleEntries)
        if (lightboxPrev) lightboxPrev.classList.toggle('hidden', !hasMultipleVisibleEntries)
        if (lightboxNext) lightboxNext.classList.toggle('hidden', !hasMultipleVisibleEntries)
        if (indexBadge) indexBadge.classList.toggle('hidden', !hasMultipleVisibleEntries)
        if (lightboxIndex) lightboxIndex.classList.toggle('hidden', !hasMultipleVisibleEntries)
      }
      function updateThumbVisibility() {
        thumbs.forEach(function (thumb) {
          var thumbMediaId = thumb.getAttribute('data-media-id') || ''
          var isVisible = visibleMediaEntries.some(function (entry) {
            return entry.id === thumbMediaId
          })
          thumb.classList.toggle('hidden', !isVisible)
          if (isVisible) {
            thumb.removeAttribute('hidden')
          } else {
            thumb.setAttribute('hidden', '')
          }
          thumb.setAttribute('aria-hidden', isVisible ? 'false' : 'true')
          thumb.tabIndex = isVisible ? 0 : -1
        })
      }
      function getVisibleEntriesForVariant(variantId) {
        if (!variantId) return allMediaEntries.slice()
        var filteredEntries = allMediaEntries.filter(function (entry) {
          if (!entry.attachedToVariant) return true
          if (entry.variantIds.length === 0) return true
          return entry.variantIds.indexOf(variantId) !== -1
        })
        return filteredEntries.length > 0 ? filteredEntries : allMediaEntries.slice()
      }
      function scrollActiveThumbIntoView(activeThumb) {
        if (!activeThumb || !thumbsContainer) return
        var containerRect = thumbsContainer.getBoundingClientRect()
        var thumbRect = activeThumb.getBoundingClientRect()
        var visibilityPadding = 12
        var isOutsideViewport = thumbRect.left < containerRect.left + visibilityPadding || thumbRect.right > containerRect.right - visibilityPadding
        if (!isOutsideViewport || typeof thumbsContainer.scrollTo !== 'function') return
        var thumbLeft = activeThumb.offsetLeft - ((thumbsContainer.clientWidth - activeThumb.offsetWidth) / 2)
        thumbsContainer.scrollTo({ left: Math.max(thumbLeft, 0), behavior: 'auto' })
      }
      function setActive(mediaId) {
        if (!mediaId) return
        renderActiveMedia(mediaId)
        var activeThumb = null
        thumbs.forEach(function (thumb) {
          var isActive = thumb.getAttribute('data-media-id') === mediaId
          thumb.classList.toggle('border-dpp-focus', isActive)
          thumb.classList.toggle('border-transparent', !isActive)
          if (isActive) {
            thumb.setAttribute('aria-current', 'true')
            activeThumb = thumb
          } else {
            thumb.removeAttribute('aria-current')
          }
        })
        scrollActiveThumbIntoView(activeThumb)
        updateGalleryControls()
        if (visibleMediaEntries.length === 0) return
        var activeIndex = getActiveIndex()
        updateIndexBadge(activeIndex)
        updateLightbox(activeIndex)
      }
      function syncVisibleMedia(variantId, preferredMediaId) {
        visibleMediaEntries = getVisibleEntriesForVariant(variantId)
        updateThumbVisibility()
        updateGalleryControls()
        var nextEntry = null
        if (preferredMediaId) {
          nextEntry = visibleMediaEntries.find(function (entry) {
            return entry.id === preferredMediaId
          }) || null
        }
        if (!nextEntry && activeMediaId) {
          nextEntry = visibleMediaEntries.find(function (entry) {
            return entry.id === activeMediaId
          }) || null
        }
        if (!nextEntry) nextEntry = visibleMediaEntries[0] || null
        if (nextEntry) {
          setActive(nextEntry.id)
        } else {
          updateIndexBadge(0)
          updateLightbox(0)
        }
      }
      function setMainFromThumb(thumb) {
        if (!thumb) return
        setActive(thumb.getAttribute('data-media-id'))
      }
      function goToRelative(step) {
        if (visibleMediaEntries.length < 2) return
        var activeIndex = getActiveIndex()
        var nextIndex = (activeIndex + step + visibleMediaEntries.length) % visibleMediaEntries.length
        var nextEntry = visibleMediaEntries[nextIndex]
        if (!nextEntry) return
        setActive(nextEntry.id)
      }
      function openLightbox(trigger) {
        if (!lightbox || !activeMediaId) return
        lastLightboxTrigger = trigger instanceof HTMLElement ? trigger : document.activeElement
        lightbox.classList.remove('hidden')
        lightbox.setAttribute('aria-hidden', 'false')
        setBodyScrollLock('gallery-lightbox', true)
        renderActiveMedia(activeMediaId)
        updateLightbox(getActiveIndex())
        window.setTimeout(function () {
          var closeButton = lightbox.querySelector('[data-gallery-lightbox-close]') || getFocusableElements(lightbox)[0]
          if (closeButton) closeButton.focus()
        }, 0)
      }
      function closeLightbox() {
        if (!lightbox) return
        lightbox.classList.add('hidden')
        lightbox.setAttribute('aria-hidden', 'true')
        lightboxItems.forEach(function (item) {
          syncEmbeddedMedia(item, false)
        })
        setBodyScrollLock('gallery-lightbox', false)
        if (lastLightboxTrigger instanceof HTMLElement) {
          window.setTimeout(function () {
            lastLightboxTrigger.focus()
          }, 0)
        }
      }
      function bindSwipe(targetElement) {
        if (!targetElement) return
        var touchStartX = 0
        var touchStartY = 0
        targetElement.addEventListener('touchstart', function (event) {
          if (!event.touches || event.touches.length !== 1) return
          touchStartX = event.touches[0].clientX
          touchStartY = event.touches[0].clientY
        }, { passive: true })
        targetElement.addEventListener('touchend', function (event) {
          if (!event.changedTouches || event.changedTouches.length !== 1) return
          var diffX = event.changedTouches[0].clientX - touchStartX
          var diffY = event.changedTouches[0].clientY - touchStartY
          if (Math.abs(diffX) < 40 || Math.abs(diffX) <= Math.abs(diffY)) return
          if (diffX < 0) {
            goToRelative(1)
          } else {
            goToRelative(-1)
          }
        }, { passive: true })
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          setMainFromThumb(thumb)
        })
      })
      if (prevButton) {
        prevButton.addEventListener('click', function () {
          goToRelative(-1)
        })
      }
      if (nextButton) {
        nextButton.addEventListener('click', function () {
          goToRelative(1)
        })
      }
      if (stage) {
        stage.addEventListener('touchstart', function (event) {
          if (!event.touches || event.touches.length !== 1) return
          stageTouchMoved = false
          stageTouchStartX = event.touches[0].clientX
          stageTouchStartY = event.touches[0].clientY
        }, { passive: true })
        stage.addEventListener('touchmove', function (event) {
          if (!event.touches || event.touches.length !== 1) return
          var diffX = Math.abs(event.touches[0].clientX - stageTouchStartX)
          var diffY = Math.abs(event.touches[0].clientY - stageTouchStartY)
          if (diffX > 12 || diffY > 12) stageTouchMoved = true
        }, { passive: true })
        stage.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            event.preventDefault()
            goToRelative(-1)
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault()
            goToRelative(1)
          }
        })
        stage.addEventListener('click', function (event) {
          if (event.target.closest('[data-gallery-prev]') || event.target.closest('[data-gallery-next]')) return
          if (stageTouchMoved) {
            stageTouchMoved = false
            return
          }
          if (window.matchMedia && !window.matchMedia('(min-width: 768px)').matches) return
          if (event.target.closest('video, iframe, button, a')) return
          var activeEntry = getMediaEntry(activeMediaId)
          if (!activeEntry || activeEntry.mediaType !== 'image') return
          openLightbox(stage)
        })
      }
      if (openLightboxButton) {
        openLightboxButton.addEventListener('click', function () {
          openLightbox(openLightboxButton)
        })
      }
      if (lightboxClose) {
        lightboxClose.addEventListener('click', closeLightbox)
      }
      if (lightboxPrev) {
        lightboxPrev.addEventListener('click', function () {
          goToRelative(-1)
        })
      }
      if (lightboxNext) {
        lightboxNext.addEventListener('click', function () {
          goToRelative(1)
        })
      }
      if (lightbox) {
        lightbox.addEventListener('click', function (event) {
          if (event.target === lightbox) closeLightbox()
        })
      }
      document.addEventListener('keydown', function (event) {
        if (!lightbox || lightbox.classList.contains('hidden')) return
        if (event.key === 'Escape') {
          closeLightbox()
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault()
          goToRelative(-1)
        } else if (event.key === 'ArrowRight') {
          event.preventDefault()
          goToRelative(1)
        }
        trapFocusWithin(event, lightbox)
      })
      bindSwipe(stage)
      bindSwipe(lightbox)
      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          var selectedOption = variantSelect.options[variantSelect.selectedIndex]
          if (!selectedOption) return
          var variantId = selectedOption.value || ''
          var resolvedMediaId = findVariantMediaIdFromOption(selectedOption)
          syncVisibleMedia(variantId, resolvedMediaId)
        })
      }
      if (!activeMediaId && allMediaEntries[0]) activeMediaId = allMediaEntries[0].id
      var initialOption = variantSelect ? variantSelect.options[variantSelect.selectedIndex] : null
      var initialVariantId = initialOption ? initialOption.value || '' : ''
      var initialPreferredMediaId = findVariantMediaIdFromOption(initialOption)
      syncVisibleMedia(initialVariantId, initialPreferredMediaId)
    })
  }
function initializeProductGallery() {
  setupProductGallery()
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeProductGallery)
} else {
  initializeProductGallery()
}
})()
